module.exports = __webpack_public_path__ + "assets/06b82afb8322b85385dbe41d56aeebd9.jpg";